import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'

import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, isAuthSessionError, setupAxios} from './app/modules/auth'
import {ThemeModeProvider} from './_metronic/partials/layout/theme-mode/ThemeModeProvider'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
const firebaseConfig = {
  apiKey: "AIzaSyAhcMWHg_-QR0aEK0eyRp4ukUeBMHVJYMQ",
  authDomain: "s4ych33se-memorymakers.firebaseapp.com",
  projectId: "s4ych33se-memorymakers",
  storageBucket: "s4ych33se-memorymakers.appspot.com",
  messagingSenderId: "1052112985202",
  appId: "1:1052112985202:web:76c07daefe690d94d2b6eb",
  measurementId: "G-CMH0Y7SJS3"
};

const firebaseApp = initializeApp(firebaseConfig);
getAnalytics(firebaseApp);
setupAxios(axios)

Chart.register(...registerables)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (isAuthSessionError(error)) {
          return false
        }
        return failureCount < 2
      },
    },
  },
})
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <ThemeModeProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </ThemeModeProvider>
      </MetronicI18nProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
